export default __webpack_public_path__ + "static/media/perfAnalTitleImg.2fe32f5f.png";